<template>
  <div>
    <nav-bar />
    <!-- <sidebar-toggle-button ref="toggleSidebarArrow"></sidebar-toggle-button> -->
    <div class="buttons-container d-flex">
      <nav class="filter-button-group">
        <div class="px-0 mx-0 justify-content-start">
          <div class="input-group col-6">
            <div class="btn-group mr-3" role="group" aria-label="Basic outlined example">
              <button type="button" :class="`btn ${mode === 'customer' ? 'btn-secondary' : 'btn-outline-secondary'}`"
                @click="setMode('customer')">{{ $t('Clients.client_account') }}</button>
              <button type="button" :class="`btn ${mode === 'address' ? 'btn-secondary' : 'btn-outline-secondary'}`"
                @click="setMode('address')">{{ $t('Clients.addressbook') }}</button>
            </div>
          </div>
        </div>
      </nav>
      <div v-if="mode === 'customer'" class="filter-button-group">
        <div class="d-flex justify-content-center align-items buttons-container">
          <button v-if="!isViewer" id="addOrder" class="btn btn-kne-orange me-2" @click="isAddDealer = true">
            <i class="fa fa-plus-circle fa-lg" aria-hidden="true" /> {{ $t('Account.add_dealer') }}
          </button>
          <toggle-button-group :buttons="orderFilterOptions" :activeButton="selectedOrderFilter"
            :handleClick="handleFilterButtonClick" />
        </div>
      </div>
      <div v-else>
        <div class="filter-button-group">
          <button v-if="!isViewer" id="addCustomer" class="btn btn-kne-orange"
            @click="add = true; clear(); setModalTitle($t('AddressBook.addTitle'))">
            <i class="fa fa-plus-circle fa-lg" aria-hidden="true" />
            {{ $t('AddressBook.sidebar.add') }}
          </button>

        </div>
      </div>
    </div>
    <div v-if="mode === 'address'">

      <!-- Addressbook -->
      <table-element v-if="current === 'addressBook'" :isShowFilter="true" :title="$t('AddressBook.title')"
        :fields="fieldsObjADR" :arrOfElement="customers" :sortSpacing="0" :isShowSelectAll="false"
        class="card mx-2 mt-2" @updateAddressBookFilterResults="updateAddressBookFilterResults">
        <template #header-actions>
          <div class="header-actions">

            <custom-json-excel :customerFields="customers_fields" :filterResults="customers"
              :name="'addressBook.xls'" />
          </div>
        </template>

        <template #body-content-desktop="content">
          <!-- List of orders -->
          <tr v-for="(customer, index) in content.results" class="table-element_hover text-center" :key="index">
            <td class="nowrap">
              <p class="table-fix-width">{{customer.name || '-'}}</p>
            </td>
            <td class="nowrap">{{customer.address || '-'}}</td>
            <td class="nowrap">{{customer.phone || '-'}}</td>
            <td class="nowrap">{{customer.fax || '-'}}</td>
            <td class="nowrap">{{customer.email || '-'}}</td>
            <td class="nowrap">{{customer.contact || '-'}}</td>
            <td>
              <input @click.prevent="modifying(customer); setModalTitle($t('AddressBook.modifyTitle'))" type="button"
                class="btn btn-kne-orange pull-right" :value="$t('AddressBook.modify')">
            </td>
          </tr>
        </template>

        <template #body-content-mobile="content">
          <div class="card m-2" v-for="customer in content.results" :key="customer['.key']">
            <div class="card-header m-1">
              <h4>{{customer.name || '-'}}</h4>
              <p><i class="fa fa-phone" />{{customer.phone || '-'}}</p>
              <p class="break-word"><i class="fa fa-envelope" />{{customer.email || '-'}}</p>
            </div>
            <div class="m-2">
              <p><i class="fa fa-home" />{{customer.address || '-'}}</p>
              <p><i class="fa fa-fax" />{{customer.fax || '-'}}</p>
              <p><i class="fa fa-address-book" />{{customer.contact || '-'}}</p>
              <div id="action">
                <input @click.prevent="modifying(customer); setModalTitle($t('AddressBook.modifyTitle'))" type="button"
                  class="btn btn-kne-orange pull-right" :value="$t('AddressBook.modify')">
              </div>
            </div>
          </div>
        </template>
      </table-element>

      <!-- Sage One -->
      <table-element v-if="current === 'sageOne'" :isShowFilter="true" :title="$t('AddressBook.title_sageOne')"
        :fields="fieldsObjSAG" :arrOfElement="sageone" :sortSpacing="0" class="card mx-2 my-5"
        @updateAddressBookFilterResults="updateAddressBookFilterResults">
        <template #header-actions>
          <a class="btn btn-sm btn-kne-orange pull-right" target="_blank"
            :href="'https://mysageone.ca.sageone.com/oauth2/auth?response_type=code&client_id=3ff1477e6ec457b7df62&redirect_uri=https://systems.keepneye.com/sageone/SageoneToken&scope=full_access&transpuid='">
            <i class="fa fa-refresh" aria-hidden="true" />
          </a>
        </template>

        <template #body-content-desktop="content">
          <!-- List of orders -->
          <tr v-for="(customer, index) in content.results" class="table-element_hover text-center" :key="index">
            <td class="nowrap">{{customer.A || customer.name}}</td>
            <td>
              <input @click.prevent="modifyingSage(customer)" type="button" class="btn btn-kne-orange pull-right w-100"
                :value="$t('AddressBook.modify')">
            </td>
          </tr>
        </template>

        <template #body-content-mobile="content">
          <!-- List of orders -->
          <div v-for="(customer, index) in content.results" class="table-element_hover text-center m-1" :key="index">
            <div class="link-dealer-table-wrapper">
              <span class="pt-2 nowrap">{{customer.A || customer.name || '-'}}</span>
              <input @click.prevent="modifyingSage(customer)" type="button" class="btn btn-kne-orange"
                :value="$t('AddressBook.modify')">
            </div>
          </div>
        </template>
      </table-element>

      <!-- Link Transporter -->
      <table-element v-if="current === 'linkTrans'" :isShowFilter="true" :title="$t('AddressBook.title_transporter')"
        :fields="fieldsObjTRA" :arrOfElement="trans" :sortSpacing="0" class="card mx-2 my-5"
        @updateAddressBookFilterResults="updateAddressBookFilterResults">
        <template #header-actions>
        </template>

        <template #body-content-desktop="content">
          <!-- List of orders -->
          <tr v-for="(transporter, index) in content.results" class="table-element_hover text-center" :key="index">
            <td class="nowrap">{{transporter.name}}</td>
            <td>
              <input @click.prevent="modifyingTransDealSage(transporter, 'transporter')" type="button"
                class="btn btn-kne-orange pull-right w-100" :value="$t('AddressBook.modify')">
            </td>
          </tr>
        </template>

        <template #body-content-mobile="content">
          <!-- List of orders -->
          <div v-for="(transporter, index) in content.results" class="table-element_hover text-center m-1" :key="index">
            <div class="link-dealer-table-wrapper">
              <span class="pt-2 nowrap">{{transporter.name}}</span>
              <input @click.prevent="modifyingTransDealSage(transporter, 'transporter')" type="button"
                class="btn btn-kne-orange" :value="$t('AddressBook.modify')">
            </div>
          </div>
        </template>
      </table-element>

      <!-- Link Dealer -->
      <table-element v-if="current === 'linkDeal'" :isShowFilter="true" :title="$t('AddressBook.title_dealer')"
        :fields="fieldsObjDEA" :arrOfElement="deal" :sortSpacing="0" class="card mx-2 my-5"
        @updateAddressBookFilterResults="updateAddressBookFilterResults">
        <template #header-actions>
        </template>

        <template #body-content-desktop="content">
          <!-- List of orders -->
          <tr v-for="(dealer, index) in content.results" class="table-element_hover text-center" :key="index">
            <td class="pt-2 nowrap">{{dealer.name}}</td>
            <td>
              <input @click.prevent="modifyingTransDealSage(dealer, 'dealer')" type="button"
                class="btn btn-kne-orange pull-right w-100" :value="$t('AddressBook.modify')">
            </td>
          </tr>
        </template>

        <template #body-content-mobile="content">
          <!-- List of orders -->
          <div v-for="(dealer, index) in content.results" class="table-element_hover text-center m-1" :key="index">
            <div class="link-dealer-table-wrapper">
              <span class="pt-2 nowrap">{{dealer.name}}</span>
              <input @click.prevent="modifyingTransDealSage(dealer, 'dealer')" type="button"
                class="btn btn-kne-orange pull-right" :value="$t('AddressBook.modify')">
            </div>
          </div>
        </template>
      </table-element>

      <loading-render v-if="isLoading" />

      <!-- Modals -->

      <!-- Modify Sage -->
      <modal :title="$t('AddressBook.sageone_change_title')" v-if="modifySage" @close-request="modifySage = false"
        closable>
        <!-- <h3>{{$t('AddressBook.sageone_change_title')}}</h3> -->
        <div class="col-12">{{sageOneChange.target.A || sageOneChange.target.name}}</div>
        <regular-datalist multiSelect :value="datalist.name" @input="setSage($event)" :secondList="customers"
          :thirdList="dealerTrans" class="col-12 form-group datalist" />
        <transition-group tag="div" name="fade" id="multi" class="container-fluid">
          <span v-if="customer.key" v-for="(customer, index) in sageCustomer" class="badge badge-kne mr-2"
            :key="customer.key">
            {{customer.value}}
            <i @click="sageCustomer.splice(index, 1)" class="fa fa-times fa-lg p-1 delete" aria-hidden="true" />
          </span>
        </transition-group>
        <div class="col-12 mt-3">
          <input :disabled="sageCustomer.length < 1" @click="SubmitmodifySage()" type="button"
            class="btn btn-kne-orange pull-right" :value="$t('AddressBook.modifySageSubmit')">
        </div>
      </modal>

      <!-- Modify Sage DealTrans -->
      <modal :title="$t('AddressBook.sageone_change_title')" v-if="modifySageDealTrans"
        @close-request="modifySageDealTrans = false" closable>
        <div class="col-12">{{sageOneChange.target.name}}</div>
        <regular-datalist :value="datalist.name" @input="datalist.name = $event.value; datalist.key = $event.key"
          :sageOne="sageone" class="col-12 form-group datalist" />
        <div class="col-12 mt-3">
          <input :disabled="datalist.key === null" @click="SubmitmodifyTransDealSage()" type="button"
            class="btn btn-kne-orange pull-right" :value="$t('AddressBook.modifySageSubmit')">
        </div>
      </modal>

      <!-- Add and modify -->
      <modal :title="modalTitle" v-if="add === true || modify === true" @close-request="add = false; modify = false"
        closable>
        <div>
          <div>
            <vue-google-autocomplete class="form-control vgaSearch m-3" id="map"
              :placeholder="$t('AddressBook.search_autocomplete')" v-on:placechanged="getAddressData"
              :country="['ca', 'us']" :fields="autocompleteSearchFields">
            </vue-google-autocomplete>
            <regular-input :value="customer.name" @input="customer.name = $event" type="text"
              :placeholder="$t('AddressBook.name') + '*'" class="col-12 form-group" />
            <regular-input :value="customer.address" @input="customer.address = $event" :disabled="true" type="text"
              :placeholder="$t('AddressBook.address') + '*'" class="col-12 form-group" />
            <regular-input :value="customer.postcode" @input="customer.postcode = $event" :disabled="true" type="text"
              :placeholder="$t('AddressBook.postCode') + '*'" class="col-12 form-group" />
            <regular-input :value="customer.city" @input="customer.city = $event" :disabled="true" type="text"
              :placeholder="$t('AddressBook.city') + '*'" class="col-12 form-group" />
            <regular-input :value="customer.province" @change="customer.province = $event" :disabled="true"
              :placeholder="$t('AddressBook.province') + '*'" class="col-12 form-group" />
            <regular-input :value="customer.country" @change="customer.country = $event" :disabled="true"
              :placeholder="$t('AddressBook.country') + '*'" class="col-12 form-group" />
          </div>

          <regular-input :value="customer.phone" @input="customer.phone = $event" type="text"
            :placeholder="$t('AddressBook.phone') + '*'" class="col-12 form-group" />
          <regular-input :value="customer.email" @input="customer.email = $event" type="text"
            :placeholder="$t('AddressBook.email')" class="col-12 form-group" />
          <regular-input :value="customer.receptionEmail" @input="customer.receptionEmail = $event" type="text"
            :placeholder="$t('AddressBook.receptionEmail')" class="col-12 form-group" />
          <regular-input :value="customer.fax" @input="customer.fax = $event" type="text"
            :placeholder="$t('AddressBook.fax')" class="col-12 form-group" />
          <regular-input :value="customer.contact" @input="customer.contact = $event" type="text"
            :placeholder="$t('AddressBook.contact')" class="col-12 form-group" />
          <regular-input :value="customer.sageID" @input="customer.sageID = $event" type="text" :disabled="true"
            :placeholder="$t('AddressBook.sageID')" class="col-12 form-group" />
          <regular-input :value="customer.comments" @input="customer.comments = $event" type="text"
            :placeholder="$t('AddressBook.comments')" class="col-12 form-group" />
        </div>
        <div class="col-12">
          <button v-if="add" class="btn btn-kne-orange w-100 mb-2" :disabled="!customerFilledForm"
            @click="addCustomer()">{{$t('AddressBook.addSubmit')}}</button>
          <button v-else class="btn btn-kne-orange w-100 mb-2" :disabled="!customerFilledForm"
            @click="modifyCustomer()">{{$t('AddressBook.modifySubmit')}}</button>
          <button v-if="modify && isAdmin && !isViewer" class="btn btn-danger w-100 mb-2"
            @click="deleteCustomer()">{{$t('AddressBook.deleteTitle')}}</button>
        </div>
      </modal>

    </div>

    <div v-show="mode==='customer'">
      <!-- Sidebar -->
      <!-- <div class="sidebar bg-darkgrey navbar-inverse side-box-shadow" v-if="$store.state.isSidebarOpen">
      <ul class="nav flex-column">
        <li class="nav-item" :class="{'current': selectedStatus === 'pending'}">
          <a class="nav-link navbar-text pull-left" @click="onSidebarAccountClick(); selectedStatus = 'pending'">{{$t('Account.sidebar.pending')}} ({{getAccounts('pending').length}})</a>
        </li>
        <li class="nav-item" :class="{'current': selectedStatus === 'approved'}">
          <a class="nav-link navbar-text pull-left" @click="onSidebarAccountClick(); selectedStatus = 'approved'">{{$t('Account.sidebar.accepted')}} ({{getAccounts('approved').length}})</a>
        </li>
        <li class="nav-item" :class="{'current': selectedStatus === 'denied'}">
          <a class="nav-link navbar-text pull-left" @click="onSidebarAccountClick(); selectedStatus = 'denied'">{{$t('Account.sidebar.refused')}} ({{getAccounts('denied').length}})</a>
        </li>
      </ul>
    </div> -->

      <!-- DESKTOP -->
      <table-element :isShowFilter="true" :title="`${$t('Account.title_pending')}`" :fields="fieldsObj"
        :arrOfElement="filteredAccounts" :sortSpacingEnd="5" class="card mx-2 mb-4 mt-2"
        @updateFilterResults="updateFilterResults">
        <template #header-actions>
        </template>

        <template #body-content-desktop="content">
          <!-- List of orders -->
          <tr v-for="(account, index) in content.results" class="table-element_hover text-center" :key="index">
            <td class="nowrap"><strong>{{account.name}}</strong></td>
            <td class="nowrap">{{account.address}} {{account.city}} {{account.province}}, {{account.postcode}}
              {{account.country}}</td>
            <td class="nowrap">
              <p class="table-fix-width">{{account.email}}</p>
            </td>
            <td class="nowrap">{{account.phone}}</td>
            <td v-if="account.odooPartnerId" class="nowrap">{{account.odooPartnerId}}</td>
            <td v-else class="nowrap"><strong><i>X</i></strong></td>
            <td class="nowrap"><strong>{{translateStatus(account.status)}}</strong></td>
            <td v-if="!isViewer" class="nowrap"><button class="btn btn-kne-orange"
                v-if="isAdmin && account.status === accountStatus.approved"
                @click="modifyBilling(account, accountStatus.billing)">Billing</button></td>
            <td v-if="!isViewer" class="nowrap"><button class="btn btn-kne-orange"
                @click="editAccount(account, accountStatus.edit)">{{$t('Account.button_edit')}}</button></td>
            <td v-if="!isViewer">
              <button v-show="account.status !== accountStatus.approved" class="btn btn-kne-orange"
                @click="editAccount(account, accountStatus.approved)">
                <i class="fa fa-check" aria-hidden="true" />
              </button>
            </td>
            <td v-if="!isViewer">
              <button v-show="account.status !== accountStatus.denied" class="btn btn-kne-orange"
                @click="editAccount(account, accountStatus.denied)">
                <i class="fa fa-times" aria-hidden="true" />
              </button>
            </td>
            <td v-if="!isViewer">
              <input @click.prevent="modifyingAuth(account); setModalTitle($t('Users.updateAuthTitle'))" :disabled="!isAdmin" type="button" class="btn btn-kne-orange pull-right" :value="$t('Users.updateAuth')">
            </td>
          </tr>
        </template>

        <template #body-content-mobile="content">
          <!-- List of orders -->
          <div v-for="(account, index) in content.results" class="card my-3 mx-2" :key="index">
            <div class="card-header m-2">
              <h4>{{account.name}}</h4>
              <p><i class="fa fa-envelope" /> {{account.email}}</p>
              <p><i class="fa fa-exclamation" /> <strong>{{translateStatus(account.status)}}</strong></p>
            </div>

            <div class="m-2">
              <p><i class="fa fa-home" /> {{account.address}} {{account.city}} {{account.province}},
                {{account.postcode}} {{account.country}}</p>
              <p><i class="fa fa-phone" /> {{account.phone}}</p>
              <p v-if="account.odooPartnerId"><i class="fa fa-id-card-o" /> {{account.odooPartnerId}}</p>
              <p v-else><i class="fa fa-id-card-o" /> <strong><i>X</i></strong></p>
            </div>

            <div class="m-2" id="action">
              <p><button class="btn btn-kne-orange"
                  @click="isEditAccount = true; editAccount(account, account.edit)">{{$t('Account.button_edit')}}</button>
              </p>
              <p v-if="account.status !== accountStatus.approved">
                <button class="btn btn-kne-orange" @click="editAccount(account, accountStatus.approved)">
                  <i class="fa fa-check" aria-hidden="true" />
                </button>
              </p>
              <p v-if="account.status !== accountStatus.denied">
                <button class="btn btn-kne-orange" @click="editAccount(account, accountStatus.denied)">
                  <i class="fa fa-times" aria-hidden="true" />
                </button>
              </p>
            </div>
          </div>
        </template>
      </table-element>

      <transition name="fade">
      <modal
        :title="modalTitle"
        v-if="modifyAuth"
        @close-request="modifyAuth = false; clear()"
        closable
      >
        <div class="m-3 w-50">
          <label for="email">
            {{$t(userFields.email.label)}}*
            <hover-tool-tip
              :text="$t('Users.modal.email_tooltip')"
              top
              right
            />
          </label>
          <regular-input
            id="email"
            :value="user.email"
            @input="user.email = $event"
            type="text" 
            :placeholder="$t(userFields.email.placeholder)" 
            class="form-group"
          />

          <label for="password">
            {{$t(userFields.password.label)}}*
            <hover-tool-tip
              :text="$t('Users.modal.password_tooltip')"
              top
              right
            />
          </label>
          <regular-input
            id="password"
            :value="user.password"
            @input="user.password = $event"
            type="text" 
            :placeholder="$t(userFields.password.placeholder)" 
            class="form-group"
          />

         <button class="btn btn-kne-orange " @click="updateUserCredentials">{{$t('Users.modal.updateAuth')}} </button>
        </div>
      </modal>  
    </transition>

      <modal :title="$t('Account.modal.title_pending_edit')" v-if="isEditAccount"
        @close-request="isEditAccount = false; onEditModalClose()" closableBackdrop closable>
        <pending-account-form ref="transporterAccountFormJS" @closeEditModal="isEditAccount = false; onEditModalClose()"
          @updateModifiedAccount="onUpdateModifiedAccount" :edittedAccount="modifiedAccount"
          :transporterList="transporters" :isEditMode="true" :newStatus="newStatus" :companyUID="companyUID">
        </pending-account-form>
      </modal>
      <modal :title="$t('Billing Discount Form')" v-if="isEditBilling" @close-request="isEditBilling = false;"
        closableBackdrop closable>
        <billing-discount-form ref="transporterAccountFormJS" @closeEditModal="onCloseBillingModal"
          :edittedAccount.sync="modifiedAccount" :transporterList="transporters" :isEditMode="true"
          :newStatus="newStatus" :companyUID="companyUID">
        </billing-discount-form>
      </modal>
      <modal :title="$t('Add New Dealer')" v-if="isAddDealer" @close-request="isAddDealer = false;" closableBackdrop
        closable>
        <new-dealer-modal ref="transporterAccountFormJS" @closeAddDealerModal="closeAddDealerModal"
          :edittedAccount="modifiedAccount" :newStatus="newStatus" :companyUID="companyUID">
        </new-dealer-modal>
      </modal>
    </div>
    <loading-render v-if="isLoading" />


  </div>
</template>

<script>
import { db } from '../../firebase'

import SidebarToggleButton from '../module/interface-components/sidebarToggleButton.vue'
import regularInput from '../module/basic-components/regularInput.vue'
import regularSelect from '../module/basic-components/regularSelect.vue'
import Navbar from '../module/interface-components/NavBar.vue'
import Modal from '../module/interface-components/Modal.vue'
import PendingAccountForm from '../module/special-components/account-admin-components/PendingAccountForm.vue'
import BillingDiscountForm from '../module/special-components/account-admin-components/BillingDiscountForm.vue'
import TableElement from '../module/special-components/Table-component/Table-Element.vue'
import LoadingRender from '../module/special-components/Other-components/LoadingRender.vue'
import ToggleButtonGroup from '../module/special-components/Other-components/ToggleButtonGroup.vue'
import NewDealerModal from '../module/special-components/Modal-templates/NewDealer-modal.vue'
// import _ from 'lodash'
import regularCheckbox from '../module/basic-components/regularCheckbox.vue'
import regularTextarea from '../module/basic-components/regularTextarea.vue'
import Search from '../module/special-components/Other-components/Search.vue'
import JsonExcel from 'vue-json-excel'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import CustomJsonExcel from '../module/special-components/Custom-packages/Custom-JsonExcel.vue'
import hoverToolTip from '../module/basic-components/hoverToolTip.vue'
import userFields from '../../constants/userFieldMappings'

export default {
  name: 'PendingAccounts',

  components: {
    regularInput,
    regularSelect,
    Navbar,
    Modal,
    PendingAccountForm,
    BillingDiscountForm,
    hoverToolTip,
    NewDealerModal,
    TableElement,
    LoadingRender,
    SidebarToggleButton,
    ToggleButtonGroup,
    regularCheckbox,
    regularTextarea,
    JsonExcel,
    Search,
    VueGoogleAutocomplete,
    CustomJsonExcel
  },

  data () {
    return {
      isLoading: false,
      mode: 'customer',
      selectedStatus: '',
      transporters: [],
      pendingAccounts: [],
      modifyAuth: false,
      user: null,
      filterResults: [],
      userFields,
      paginate: ['filterResults'],
      fields: {
        '.key': '',
        address: '',
        email: '',
        fax: '',
        status: '',
        name: '',
        phone: ''
      },
      isAddDealer: false,
      searchHistory: [],
      searchType: '',
      searchText: '',
      historyTypeTag: '',
      isCreateAccount: false,
      isEditAccount: false,
      isEditBilling: false,
      modifiedAccount: {}, /** Sent as props to @component pending-account-form */
      originalModifiedAccount: null,
      newStatus: '', /** Sent as props to @component pending-account-form */
      accountStatus: {
        approved: 'Approved',
        pending: 'Pending',
        denied: 'Denied',
        edit: 'Edit',
        billing: 'Billing'
      },
      fieldsObj: [
       {
         text: this.$t('Account.name'),
         type: 'name',
         value: ''
       },
       {
         text: this.$t('Account.address'),
         type: 'address',
         value: ''
       },
       {
         text: this.$t('Account.email'),
         type: 'email',
         value: ''
       },
       {
         text: this.$t('Account.phone'),
         type: 'phone',
         value: ''
       },
       {
         text: this.$t('Account.odoo_id'),
         type: 'odooPartnerId',
         value: ''
       },
       {
         text: this.$t('Account.status.account_status'),
         type: 'status',
         value: ''
       }
      ],
      selectedOrderFilter: 'approved',
      // Addressbook data
      customers_fields: {
          'name': 'name',
          'address': 'address',
          'city': 'city',
          'email': 'email',
          'phone': 'phone',
          'postcode': 'postcode',
          'province': 'province',
          'country': 'country',
          'comments': 'comments',
          'contact': 'contact'
        },
        current: 'addressBook',
        sageOneNameFilter: '',
        sageOneChange: {
          target: {},
          type: ''
        },
        modifySage: false,
        modifySageDealTrans: false,
        datalist: {
          name: '',
          key: null
        },
        sageCustomer: [],
        add: false,
        modify: false,
        key: '',
        customer: {
          name: '',
          address: '',
          phone: '',
          fax: '',
          email: '',
          receptionEmail: '',
          contact: '',
          postcode: '',
          city: '',
          province: '',
          country: '',
          comments: '',
          place_id: '',
          lat: '',
          long: '',
          sageID: ''
        },
        provinces: ['BC', 'ON', 'NL', 'NS', 'PE', 'NB', 'QC', 'MB', 'SK', 'AB', 'NT', 'NU', 'YT'],
        addressbookFields: {
          name: '',
          address: '',
          phone: '',
          fax: '',
          email: '',
          contact: ''
        },
        addressbookfilterResults: [],
        filterResultsSageOne: [],
        customers: [],
        dealerTrans: [],
        sageone: [],
        addressbookPaginate: ['filterResults', 'filterResultsSageOne'],
        trans: [],
        deal: [],
        autocompleteSearchFields: ['address_components', 'adr_address', 'alt_id', 'formatted_address', 'formatted_phone_number', 'geometry', 'icon',
         'id', 'name', 'business_status', 'photo', 'place_id', 'scope', 'type', 'url', 'utc_offset_minutes', 'vicinity'],
         addressbookSearchHistory: [],
         addressbookSearchType: '',
        addressbookSearchText: '',
        addressbookHistoryTypeTag: '',
        modalTitle: '', // Title for Add and modify user
        fieldsObjADR: [
          {
            text: this.$t('AddressBook.name'),
            type: 'name',
            value: ''
          },
          {
            text: this.$t('AddressBook.address'),
            type: 'address',
            value: ''
          },
          {
            text: this.$t('AddressBook.phone'),
            type: 'phone',
            value: ''
          },
          {
            text: this.$t('AddressBook.fax'),
            type: 'fax',
            value: ''
          },
          {
            text: this.$t('AddressBook.email'),
            type: 'email',
            value: ''
          },
          {
            text: this.$t('AddressBook.contact'),
            type: 'contact',
            value: ''
          },
          {
            text: '',
            type: '',
            value: ''
          }
        ],
        fieldsObjSAG: [
          {
            text: this.$t('AddressBook.name'),
            type: 'A',
            value: ''
          },
          {
            text: '',
            type: '',
            value: ''
          }
        ],
        fieldsObjTRA: [
          {
            text: this.$t('AddressBook.name'),
            type: 'name',
            value: ''
          },
          {
            text: '',
            type: '',
            value: ''
          }
        ],
        fieldsObjDEA: [
          {
            text: this.$t('AddressBook.name'),
            type: 'name',
            value: ''
          },
          {
            text: '',
            type: '',
            value: ''
          }
        ]
    }
  },
  created () {
    this.initialize()
  },

  methods: {
    initialize () {
    this.isLoading = true
    this.isScreenSmall = window.innerWidth < 800
    this.isScreenSmall = window.innerWidth < 800
    var id = this.companyUID

    this.$bindAsArray('pendingAccounts', db.ref('users/pending-creation').orderByChild('transporterUid').equalTo(this.companyUID), null, () => {
      this.isLoading = false
    })
    // this.$bindAsArray('pendingAccounts', db.ref('users/dev'), null, () => {
    //   this.filteredSearchMethod()
    //   this.isLoading = false
    // })

    this.$bindAsArray('transporters', db.ref('users/transporters'), null, () => {})
    this.$bindAsArray('customers', db.ref('database/transporter/' + id + '/addressbook'), null, () => {
      this.isLoading = false
    })

    this.$bindAsArray('sageone', db.ref('sageoneid/' + id), null, () => {
      this.filteredSearchMethodSage()
    })
    this.$bindAsArray('trans', db.ref('users/transporters/' + id + '/listTrans'))
    this.$bindAsArray('deal', db.ref('users/transporters/' + id + '/listDeal'))
    this.$bindAsArray('dealerTrans', db.ref('database/transporter/' + id + '/customer'), null, () => {
      this.filteredSearchMethodSage()
      this.isLoading = false
    })
  },
    setMode (mode) {
        this.mode = mode
        this.loading = true
        this.$nextTick(() => {
          this.initialize()
        })
      },
    handleFilterButtonClick (buttonName) {
      this.selectedOrderFilter = buttonName
      this.onSidebarAccountClick()
      this.selectedStatus = buttonName
    },
    onSidebarAccountClick () {
      if (!this.selectedStatus) return this.pendingAccounts

      const accounts = this.getAccounts()

      return accounts
    },

    modifyingAuth: function (user) {
      this.modifyAuth = true
      console.log({ user })
      this.user = user
    },

    async updateUserCredentials () {
      const payload = {
        uid: this.user['.key'],
        email: this.user.email || null,
        password: this.user.password || null
      }

      if (!payload.email && !payload.password) {
        alert(this.$t('Users.modal.nothing_to_update'))
        return
      }

      try {
        const response = await fetch(`${process.env.BACKEND_API_URL}/update-user-auth`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        })

        if (response.ok) {
          alert('User credentials updated successfully.')
        } else {
          const errorText = await response.text()
          alert('Update failed: ' + errorText)
        }
      } catch (err) {
        console.error('Fetch error:', err)
        alert('An error occurred.')
      }
    },

    getAccounts (type) {
      const accounts = [...this.pendingAccounts]
      const currentStatus = type || this.selectedStatus
      let returnedAccounts = []

      accounts.forEach(account => {
        const isAccountSameStatus = currentStatus === account.status.toLowerCase() // If the status of the ticket is the same as the status option

        if (isAccountSameStatus) returnedAccounts.push(account)
      })

      return returnedAccounts
    },

    updateFilterResults (sortResults) {
      this.filterResults = sortResults
    },

    onCloseBillingModal () {
      this.isEditBilling = false
    },

    closeAddDealerModal () {
      this.isAddDealer = false
    },

    editAccount (account, status) {
      this.modifiedAccount = account
      this.originalModifiedAccount = JSON.parse(JSON.stringify(this.modifiedAccount))
      this.isEditAccount = true
      this.newStatus = status
    },

    onEditModalClose () {
      this.$refs.transporterAccountFormJS.restoreTransporterLinkData()
      this.$bindAsArray('pendingAccounts', db.ref('users/pending-creation').orderByChild('transporterUid').equalTo(this.companyUID), null, () => {
        this.isLoading = false
      })
    },
    onUpdateModifiedAccount (newModifiedAccount) {
      this.modifiedAccount = newModifiedAccount
      this.originalModifiedAccount = JSON.parse(JSON.stringify(newModifiedAccount))
    },

    modifyBilling (account, status) {
      this.modifiedAccount = account
      this.isEditBilling = true
      this.newStatus = status
    },

    translateStatus (status) {
      switch (status.toLowerCase()) {
        case this.accountStatus.denied.toLowerCase():
          return `${this.$t('Account.status.account_denied')}`

        case this.accountStatus.pending.toLowerCase():
          return `${this.$t('Account.status.account_pending')}`

        case this.accountStatus.approved.toLowerCase():
          return `${this.$t('Account.status.account_approved')}`

        default:
          console.log('Error unknown status', status)
          return ''
      }
    },

    // Addressbook methods
    updateAddressBookFilterResults (sortResults) {
      this.addressbookfilterResults = sortResults
      this.filterResultsSageOne = sortResults
    },
    /** Because we use the same modal to edit/add */
    setModalTitle (title) {
      this.modalTitle = title
    },

    getAddressData (addressData, placeResultData) {
      this.customer.name = ''
      this.customer.address = ''
      this.customer.postcode = ''
      this.customer.phone = ''
      this.customer.city = ''
      this.customer.province = ''
      this.customer.country = ''
      this.customer.place_id = ''
      this.customer.lat = 0
      this.customer.long = 0

      this.customer.name = placeResultData.name
      this.customer.address = placeResultData.formatted_address.split(',')[0]
      this.customer.postcode = addressData.postal_code
      this.customer.phone = placeResultData.formatted_phone_number
      this.customer.city = addressData.locality
      this.customer.province = addressData.administrative_area_level_1
      this.customer.country = addressData.country
      this.customer.place_id = placeResultData.place_id
      this.customer.lat = addressData.latitude
      this.customer.long = addressData.longitude
    },
    setSage (event) {
      console.log(event)
      if (event.key) {
        this.datalist.name = event.originalVal
        delete event.originalVal
        this.sageCustomer.push(event)
      } else this.datalist.name = event.value
      // this.datalist.key = event.key
      // this.datalist.dealer = event.dealer
      // this.datalist.transporter = event.transporter
    },
    SubmitmodifySage () {
      // console.log('submit')
      this.sageCustomer.forEach((customer) => {
        if (customer.dealer && customer.key) {
          db.ref('users/dealers/' + customer.key + '/sageID').set(this.sageOneChange.target.B)
          // ======================== ADD MODIFICATION DEALER SAGE LOG =======================
          this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'SAGE_DEALER_MODIFICATION', 'targetUID': customer.key, 'date': Date.now(), 'targetName': this.sageOneChange.target.A})
          // ======================== ADD MODIFICATION DEALER SAGE LOG =======================
        }
        if (customer.transporter && customer.key) {
          db.ref('users/transporters/' + customer.key + '/sageID').set(this.sageOneChange.target.B)
          // ======================== ADD MODIFICATION TRANSPORTER SAGE LOG =======================
          this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'SAGE_TRANSPORTER_MODIFICATION', 'targetUID': customer.key, 'date': Date.now(), 'targetName': this.sageOneChange.target.A})
          // ======================== ADD MODIFICATION TRANSPORTER SAGE LOG =======================
        }
        if (!customer.dealer && !customer.transporter && customer.key) {
          db.ref('database/transporter/' + this.companyUID + '/addressbook/' + customer.key + '/sageID').set(this.sageOneChange.target.B)
          // ======================== ADD MODIFICATION SAGE LOG =======================
          this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'SAGE_MODIFICATION', 'targetUID': customer.key, 'date': Date.now(), 'targetName': this.sageOneChange.target.A})
          // ======================== ADD MODIFICATION SAGE LOG =======================
        }
      })
      db.ref('sageoneid/' + this.companyUID).child(this.sageOneChange.target['.key']).child('C').set(this.sageCustomer).then(() => {
        this.modifySage = false
      })
    },
    SubmitmodifyTransDealSage () {
      var uid = this.companyUID
      if (this.sageOneChange.type === 'transporter') {
        db.ref('users/transporters').child(this.sageOneChange.target['.key']).update({sageID: this.datalist.key}).then(() => {
          this.modifySageDealTrans = false
        })
        db.ref('users/transporters').child(uid).child('listTrans').child(this.sageOneChange.target['.key']).update({linked: true})
        // ======================== ADD SAGE TRANSPORTER LINK LOG =======================
        this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'SAGE_TRANSPORTER_LINK', 'targetUID': this.sageOneChange.target['.key'], 'date': Date.now(), 'targetName': this.sageOneChange.target.name})
        // ======================== ADD SAGE TRANSPORTER LINK LOG =======================
      } else {
        db.ref('users/dealers').child(this.sageOneChange.target['.key']).update({sageID: this.datalist.key}).then(() => {
          this.modifySageDealTrans = false
        })
        db.ref('users/transporters').child(uid).child('listDeal').child(this.sageOneChange.target['.key']).update({linked: true})
        // ======================== ADD SAGE LINK LOG =======================
        this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'SAGE_LINK', 'targetUID': this.sageOneChange.target['.key'], 'date': Date.now(), 'targetName': this.sageOneChange.target.name})
        // ======================== ADD SAGE LINK LOG =======================
      }
    },
    evaluateFiltering (attr, val) {
      this.addressbookFields[attr] = val

      var isAttrDupe = false
      if (val === '') return

      this.addressbookSearchHistory.find((o, i) => {
        if (o.searchType === attr) {
          var storedDupeTag = this.setSearchedItemTag(attr)
          this.addressbookSearchHistory[i] = {
            searchType: attr, searchText: val, historyTypeTag: storedDupeTag}
          isAttrDupe = true
          return
        }
      })
      if (!isAttrDupe) {
        this.addSearchedItem(attr, val)
      }
    },
    setSearchedItemTag (attr) {
      var storedTag
      if (attr === 'name') { storedTag = this.$t('AddressBook.name') }
      if (attr === 'phone') { storedTag = this.$t('AddressBook.phone') }
      if (attr === 'email') { storedTag = this.$t('AddressBook.email') }
      if (attr === 'address') { storedTag = this.$t('AddressBook.address') }
      if (attr === 'fax') { storedTag = this.$t('AddressBook.fax') }
      if (attr === 'contact') { storedTag = this.$t('AddressBook.contact') }
      return storedTag
    },
    addSearchedItem (searchedType, searchedText) {
      var storedTag = this.setSearchedItemTag(searchedType)
      this.addressbookSearchHistory.push({searchType: searchedType, searchText: searchedText, historyTypeTag: storedTag})
    },
    removeSearchedItem (index, attr) {
      this.addressbookSearchHistory.splice(index, 1)
      this.evaluateFiltering(attr, '')
    },

    filteredSearchMethodSage: window._.debounce(function () {
      this.filterResultsSageOne = []
      this.filterResultsSageOne = this.sageone.filter((entry) => {
        // var result = true
        var reg = this.sageOneNameFilter.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
        var re = new RegExp(reg, 'i')
        var result = re.test(entry.A)
        // if (result === false) break
        return result
      })
      // this.filterResultsSageOne = this.filterResultsSageOne.concat(this.dealerTrans)
    }, 100),
    addCustomer: function () {
      db.ref('database/transporter/' + this.companyUID + '/addressbook').push().set(this.customer).then(() => {
        // ======================== ADD CUSTOMER LOG =======================
        this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'ADD_CUSTOMER', 'customerName': this.customer.name, 'date': Date.now()})
        // ======================== ADD CUSTOMER LOG =======================
        this.add = !this.add
        this.clear()
      })
    },
    modifyCustomer: function () {
      db.ref('database/transporter/' + this.companyUID + '/addressbook/' + this.key).update(this.customer).then(() => {
        // ======================== ADD CUSTOMER MODIFICATION LOG =======================
        this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'MODIFY_CUSTOMER', 'customerName': this.customer.name, 'date': Date.now()})
        // ======================== ADD CUSTOMER MODIFICATION LOG =======================
        this.modify = !this.modify
        this.clear()
      })
    },
    modifying: function (customer) {
      this.modify = true
      for (var attr in this.customer) {
        this.customer[attr] = customer[attr]
        if (customer[attr] === undefined) this.customer[attr] = ''
      }
      this.key = customer['.key']
    },
    modifyingSage: function (customer) {
      this.sageOneChange.target = customer
      this.datalist.name = ''
      this.datalist.key = null
      this.sageCustomer = Object.values(customer.C || {})
      this.modifySage = true
    },
    modifyingTransDealSage (dealerTrans, type) {
      this.sageOneChange.target = dealerTrans
      this.sageOneChange.type = type
      this.datalist.name = ''
      this.datalist.key = null
      this.modifySageDealTrans = true
    },
    clear: function () {
      for (var attr in this.customer) {
        this.customer[attr] = ''
      }
    },
    deleteCustomer: function () {
      db.ref('database/transporter/' + this.companyUID + '/addressbook/').child(this.key).remove().then(() => {
        // ======================== ADD CUSTOMER MODIFICATION LOG =======================
        this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'DELETE_CUSTOMER', 'customerName': this.customer.name, 'date': Date.now()})
        // ======================== ADD CUSTOMER MODIFICATION LOG =======================
        this.modify = !this.modify
        this.clear()
      })
    },

    onResize: window._.debounce(function () {
      this.isScreenSmall = window.innerWidth < 800
    }, 50)
  },

  computed: {
    customerFilledForm: function () {
      if (
        this.customer.name !== '' &&
        this.customer.phone !== '' &&
        this.customer.address !== '' &&
        this.customer.postcode !== '') return true
      else return false
    },
    companyUID () {
      return this.$store.state.authorization.company
    },
    uid () {
      return this.$store.state.user.uid
    },

    filteredAccounts () {
      return this.onSidebarAccountClick()
    },

    isAdmin () {
      return this.$store.state.authorization.role === 'Admin'
    },

    isViewer () {
      return this.$store.state.authorization.role === 'Viewer'
    },

    orderFilterOptions () {
      return [
        { label: `${this.$t('Account.sidebar.pending')} (${this.getAccounts('pending').length})`, value: 'pending' },
        { label: `${this.$t('Account.sidebar.accepted')} (${this.getAccounts('approved').length})`, value: 'approved' },
        { label: `${this.$t('Account.sidebar.refused')} (${this.getAccounts('denied').length})`, value: 'denied' }
      ]
    }
  },

  mounted () {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },

  beforeDestroy () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },

  watch: {
    sageone: function () {
      this.filteredSearchMethodSage()
    },
    dealers: function () {
      this.filteredSearchMethodSage()
    },
    transporters: function () {
      this.filteredSearchMethodSage()
    },
    dealerTrans: function () {
      this.filteredSearchMethodSage()
    }
  }
}
</script>

<style scoped>
  .link-dealer-table-wrapper {
    display: flex;
    justify-content: space-between;
  }
  .delete {
    border-radius: 4px;
    cursor: pointer;
  }
  .delete:hover {
    background-color: #666e71;
    transition: all linear 150ms;
  }
  .badge-kne {
    background-color: #2c2d2f;
  }

  .table thead th {
    border-bottom: 1px solid #eceeef;
    border-top: none;
  }
  .current {
    border-left: 3px solid #f7941e;
  }
  .datalist {
    margin-bottom: 0px;
  }
  .linked {
    background-color: #B4EEB4;
  }
  .break-word {
    overflow-wrap: break-word;
  }
  .vgaSearch {
    max-width: 97%;
    border: 1px solid;
  }
  .buttons-container {
    display: flex;
  }
  .header-actions{
    display:flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }
  .fa-check {
    font-size: 0.75rem
  }

  @media (max-width: 700px){
    .buttons-container {
      flex-direction: column !important;
      justify-content: flex-start;
      align-items: flex-start;
    }

    #addOrder {
      width: 60%;
    }
  }
</style>
